import { render, staticRenderFns } from "./desprenoi.vue?vue&type=template&id=6a9658a8&"
import script from "./desprenoi.vue?vue&type=script&lang=js&"
export * from "./desprenoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports